import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "dataTable" }
const _hoisted_4 = { class: "container-header" }
const _hoisted_5 = { tabindex: "-1" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalChoixTypeDocuments = _resolveComponent("ModalChoixTypeDocuments")!
  const _component_ModalDownloadDocuments = _resolveComponent("ModalDownloadDocuments")!
  const _component_ModalChoixNomZip = _resolveComponent("ModalChoixNomZip")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('intervention.non-preventive.filter')), 1),
          _createVNode(_component_ButtonBlue, {
            disabled: _ctx.tableData.length === 0 && _ctx.isLoading,
            "on-click": _ctx.selectionnerTypeDocument,
            text: _ctx.$t('bouton.selection.type.documents'),
            class: "button-confirm btn"
          }, null, 8, ["disabled", "on-click", "text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$tc('document.reglementaire.dataTable.title', +_ctx.count)), 1),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isDownloadDisabled)
              ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                  key: 0,
                  imgUrl: _ctx.iconeDownload,
                  title: _ctx.$t('list.download.selection'),
                  class: "button-left",
                  onClick: _ctx.downloadDocuments
                }, null, 8, ["imgUrl", "title", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.count > 0)
              ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                  key: 1,
                  imgUrl: _ctx.iconeDownload,
                  title: _ctx.$t('list.download.all'),
                  class: "button-right",
                  onClick: _ctx.downloadAll
                }, null, 8, ["imgUrl", "title", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.tableData.length === 0 && _ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, {
              key: 0,
              class: "loader"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref: "content",
              class: "datatable-container-smaller",
              onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
            }, [
              _createVNode(_component_DataTable, {
                documentListToDownload: _ctx.documentListToDownload,
                isLoading: _ctx.isLoading,
                noDataText: _ctx.$t('search.notFound'),
                tableData: _ctx.tableData,
                tableHeader: _ctx.tableHeader,
                onSelect: _ctx.doSelect,
                onSort: _ctx.doSort
              }, null, 8, ["documentListToDownload", "isLoading", "noDataText", "tableData", "tableHeader", "onSelect", "onSort"])
            ], 544))
      ])
    ]),
    (_ctx.displayModalTypeDocument && !_ctx.isListTypesLoading)
      ? (_openBlock(), _createBlock(_component_ModalChoixTypeDocuments, {
          key: 0,
          "selected-types": _ctx.filter.documentTypeList,
          "types-documents": _ctx.typeDocumentList,
          onCancel: _ctx.modaleChoixTypesCancel,
          onValider: _ctx.validerTypes
        }, null, 8, ["selected-types", "types-documents", "onCancel", "onValider"]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_ModalDownloadDocuments, {
          key: 1,
          documentTypeList: _ctx.typeDocumentList,
          "nb-documents-modal": _ctx.nbDocumentsModal,
          onCancel: _ctx.cancel,
          onDownloadDocuments: _ctx.setFilterForDownloadAllDocuments
        }, null, 8, ["documentTypeList", "nb-documents-modal", "onCancel", "onDownloadDocuments"]))
      : _createCommentVNode("", true),
    (_ctx.showModalNomZip)
      ? (_openBlock(), _createBlock(_component_ModalChoixNomZip, {
          key: 2,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalNomZip = false)),
          onDownload: _ctx.downloadAllDocuments
        }, null, 8, ["onDownload"]))
      : _createCommentVNode("", true),
    (_ctx.isZipLoading || _ctx.isListTypesLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}